import { defineMessages } from 'react-intl-next';

export const i18n: {
	space: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterSpacePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	space: {
		id: 'search-page.filters.names.space',
		defaultMessage: 'Space',
		description: 'Label for filtering by space',
	},
	confluenceFilterSpacePlaceholder: {
		id: 'search-page.confluence.filter.space.placeholder',
		defaultMessage: 'Find spaces',
		description: 'Placeholder for space filter search input',
	},
	confluenceFilterLabelSelected: {
		id: 'search-page.confluence.filter.label.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter label selected',
	},
	confluenceFilterLabelUnselected: {
		id: 'search-page.confluence.filter.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Confluence filter label unselected',
	},
	confluenceIconLabel: {
		id: 'search-page.confluence.filter.icon.label',
		defaultMessage: 'Confluence filter',
		description:
			'An icon that is displayed when there are no products selected to signify that the filter is associated with Confluence',
	},
});
